/* DEFAULT/INTERNAL PAYMENT */
import * as React from "react";
import {CheckoutStep} from "../../../Checkout";
import {useTranslation} from "react-i18next";
import {useCheckoutViewContext} from "../../../CheckoutContextProvider/CheckoutViewContextProvider";
import {PurchaseButtonProps} from "./PurchaseButtonProps";

const ModuleButton: React.FC<PurchaseButtonProps> = ({paymentModule, purchaseButtonErrors}) => {
  const checkoutView = useCheckoutViewContext();
  const {t} = useTranslation(["errorcodes", "translations"]);

  if (!paymentModule) {
    return null;
  }

  return (
    <paymentModule.PurchaseButton
      gotoHandling={() => checkoutView.gotoStep(CheckoutStep.PAYMENT)}
      label={t("checkout.purchaseNow")}
      handleError={purchaseButtonErrors}
    />
  );
};

export default ModuleButton;
